import fetch from "auth/FetchInterceptor";

const posService = {};

// Helper to get store ID header
const getStoreHeaders = () => {
  const storeId = localStorage.getItem("store_id") || "1";
  return { "Store-ID": storeId };
};

// ========== Terminal Management ==========

posService.getTerminals = function () {
  return fetch({
    url: `/terminals/`,
    method: "GET",
    headers: getStoreHeaders(),
  });
};

posService.createTerminal = function (data) {
  return fetch({
    url: `/terminals/`,
    method: "POST",
    data: data,
    headers: getStoreHeaders(),
  });
};

posService.getTerminalById = function (id) {
  return fetch({
    url: `/terminals/${id}/`,
    method: "GET",
    headers: getStoreHeaders(),
  });
};

posService.updateTerminal = function (id, data) {
  return fetch({
    url: `/terminals/${id}/`,
    method: "PUT",
    data: data,
    headers: getStoreHeaders(),
  });
};

posService.deleteTerminal = function (id) {
  return fetch({
    url: `/terminals/${id}/`,
    method: "DELETE",
    headers: getStoreHeaders(),
  });
};

// ========== Session (Shift) Management ==========

posService.getSessions = function (params = {}) {
  const queryString = new URLSearchParams(params).toString();
  return fetch({
    url: `/sessions/${queryString ? `?${queryString}` : ""}`,
    method: "GET",
    headers: getStoreHeaders(),
  });
};

posService.openSession = function (data) {
  return fetch({
    url: `/sessions/`,
    method: "POST",
    data: data,
    headers: getStoreHeaders(),
  });
};

posService.closeSession = function (sessionId, data) {
  return fetch({
    url: `/sessions/${sessionId}/close/`,
    method: "POST",
    data: data,
    headers: getStoreHeaders(),
  });
};

// ========== POS Orders ==========

posService.getOrders = function (params = {}) {
  const queryString = new URLSearchParams(params).toString();
  return fetch({
    url: `/pos/orders/${queryString ? `?${queryString}` : ""}`,
    method: "GET",
    headers: getStoreHeaders(),
  });
};

posService.createOrder = function (data) {
  return fetch({
    url: `/pos/orders/create/`,
    method: "POST",
    data: data,
    headers: getStoreHeaders(),
  });
};

posService.getOrderById = function (id) {
  return fetch({
    url: `/pos/orders/${id}/`,
    method: "GET",
    headers: getStoreHeaders(),
  });
};

posService.updateOrder = function (id, data) {
  return fetch({
    url: `/pos/orders/${id}/`,
    method: "PUT",
    data: data,
    headers: getStoreHeaders(),
  });
};

posService.partialRefundOrder = function (id, data) {
  return fetch({
    url: `/pos/orders/${id}/partial-refund/`,
    method: "POST",
    data: data,
    headers: getStoreHeaders(),
  });
};

// ========== Reports ==========

posService.getSalesReport = function (params = {}) {
  const queryString = new URLSearchParams(params).toString();
  return fetch({
    url: `/reports/sales/${queryString ? `?${queryString}` : ""}`,
    method: "GET",
    headers: getStoreHeaders(),
  });
};

posService.getProductReport = function (params = {}) {
  const queryString = new URLSearchParams(params).toString();
  return fetch({
    url: `/reports/products/${queryString ? `?${queryString}` : ""}`,
    method: "GET",
    headers: getStoreHeaders(),
  });
};

posService.getCashierPerformance = function (params = {}) {
  const queryString = new URLSearchParams(params).toString();
  return fetch({
    url: `/reports/cashier-performance/${queryString ? `?${queryString}` : ""}`,
    method: "GET",
    headers: getStoreHeaders(),
  });
};

posService.getCashierRefunds = function (params = {}) {
  const queryString = new URLSearchParams(params).toString();
  return fetch({
    url: `/reports/cashier-refunds/${queryString ? `?${queryString}` : ""}`,
    method: "GET",
    headers: getStoreHeaders(),
  });
};

export default posService;
